/*!
 * ADYJO DevTools Watch
 * Deterrent only. Not a real security boundary.
 */
(function (window, document) {
  'use strict';

  function setFlag(open) {
    document.documentElement.classList.toggle('adyjo-devtools-open', open);
    if (open) {
      document.documentElement.setAttribute('data-adyjo-devtools', 'open');
    } else {
      document.documentElement.removeAttribute('data-adyjo-devtools');
    }
  }

  function isOpen(threshold) {
    var widthDiff = Math.abs(window.outerWidth - window.innerWidth);
    var heightDiff = Math.abs(window.outerHeight - window.innerHeight);
    return widthDiff > threshold || heightDiff > threshold;
  }

  function init() {
    var threshold = 160;
    var last = null;

    setInterval(function () {
      try {
        var open = isOpen(threshold);
        if (open !== last) {
          last = open;
          setFlag(open);
        }
      } catch (err) {}
    }, 1000);

    window.addEventListener('resize', function () {
      try {
        var open = isOpen(threshold);
        if (open !== last) {
          last = open;
          setFlag(open);
        }
      } catch (err) {}
    }, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, false);
  } else {
    init();
  }
})(window, document);
